import { Env } from '@/core/EnvUtils'

const FRAME_ROUTER_GUARD_DISABLED = 'FRAME_ROUTER_GUARD_DISABLED'
const FRAME_RELOGIN_DISABLED = 'FRAME_RELOGIN_DISABLED'
const MAPP_RELOGIN_DISABLED = 'FRAME_MAPP_RELOGIN_DISABLED'
const MAPP_BLACK_LIST = 'FRAME_MAPP_BLACK_LIST'

function getBooleanByName(name: string): boolean {
  return JSON.parse(window.localStorage.getItem(name) ?? 'false')
}

function getStringArrayByName(name: string): string[] {
  return JSON.parse(window.localStorage.getItem(name) ?? '[]')
}

/**
 * Checks if the Before Router Guard in framework is enabled. If true, the guard will do nothing except calling 'next()' directly.
 */
export const isRouterGuardDisabled = () => {
  if (Env.isRelease()) return false

  return getBooleanByName(FRAME_ROUTER_GUARD_DISABLED)
}

/**
 * Checks if re-login logic of frame is enabled. This flag only effects the re-login of frame,
 * not including the 'requestReloging' invocations in micro-apps
 */
export const isFrameReloginDisabled = () => {
  if (Env.isRelease()) return false

  return getBooleanByName(FRAME_RELOGIN_DISABLED)
}

/**
 * Checks if disable the invocation of 'requestRelogin' in micro-apps.
 */
export const isMappReloginDisabled = () => {
  if (Env.isRelease()) return false

  return getBooleanByName(MAPP_RELOGIN_DISABLED)
}

export const getMappBlackList = () => {
  if (Env.isRelease()) return []

  return getStringArrayByName(MAPP_BLACK_LIST)
}

export default {}
